<app-pat-payment-panel-stripe-generic
  type="STRIPE"
  [payButtonText]="'payment.pay-with-credit-card' | translate"
></app-pat-payment-panel-stripe-generic>
